import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import UpdateServiceDetail from '../../components/admincomponents/UpdateServiceDetail';

function UpdateService({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <UpdateServiceDetail />            
    </>
  );
}

export default UpdateService;
